import moment from 'moment-js'

export const utils = {
  vuexProductToApiFormat: function (registeredProducts) {
    
    let formattedProducts = []
    registeredProducts.forEach((prod) => {
      let singleProd = Object.create(null)
      singleProd.product_category_id = prod.category_id
      singleProd.name = prod.prod_name
      singleProd.serial_number = prod.serial
      singleProd.purchase_date = moment(prod.purchase_date).format('yyyy-MM-dd')
      singleProd.shop_type = prod.shop_type
      
      if (prod.shop_type === 'online') {
        singleProd.shop_www = prod.shop_www
      } else {
        singleProd.shop_name = prod.shop_name
        singleProd.shop_address = prod.shop_address
        singleProd.shop_city = prod.shop_city
        singleProd.shop_zip_code = prod.shop_zip_code
      }

      singleProd.document_purchase_name = prod.purchase_document_server_name
      singleProd.document_warranty_name = prod.warranty_document_server_name
      formattedProducts.push(singleProd)
    })

    return formattedProducts
    
  }
}